'use client';
import React from 'react';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { Image } from '@components/Image';
import {
  CountrySelectProps as Props,
  SelectIconProps,
  optionType,
} from './CountrySelect.type';
import cn from './CountrySelect.module.scss';
export function CountrySelect(props: Props) {
  const selectedOption = React.useMemo(() => {
    return getSelectedOption(props.options, props.value);
  }, [props.options, props.value]);

  const FlagImage = ({ type }: { type: string }): JSX.Element => {
    const url = `https://purecatamphetamine.github.io/country-flag-icons/3x2/${type}.svg`;
    return <Image url={url} alt={type} width={17} />;
  };

  const renderValue = () => {
    if (selectedOption)
      return (
        <div className={cn.renderValue}>
          <FlagImage type={selectedOption.flagCode} />
          <span>{selectedOption.code}</span>
        </div>
      );
  };

  const onChangeSelection = (e: SelectChangeEvent) => {
    props.onChange(e.target.value);
  };

  return (
    <>
      <Select
        disabled={props.disabled}
        name={props.name}
        value={props.value}
        onChange={onChangeSelection}
        renderValue={renderValue}
        IconComponent={SelectIcon}
        sx={{
          '.MuiSelect-select': {
            padding: '0 !important',
            paddingRight: '0 !important',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            '-webkit-text-fill-color': 'inherit !important',
          },
          '.MuiOutlinedInput-notchedOutline': {
            padding: 0,
          },
        }}
        inputProps={{
          'data-testid': `lf_${props.name}`,
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: '250px',
              maxWidth: '340px',
              minWidth: '320px',
            },
          },
        }}
        className={cn.selectionBlock}
      >
        {props.options.map((option: any) => (
          <MenuItem
            key={option.value}
            value={option.value}
            className={cn.selectionBlock__option}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
}

const SelectIcon = (props: SelectIconProps) => (
  <span className={`${props.className} ${cn.selectionBlock__icon}`}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 54.365">
      <path
        d="M51.156,65.79c-.984,1-.984,1-1.967,0S7.595,24.127,7.595,24.127a4.331,4.331,0,1,0-6.126,6.126L46.812,75.595a4.942,4.942,0,0,0,3.36,1.587A4.7,4.7,0,0,0,53.5,75.635l45.4-45.4a4.332,4.332,0,1,0-6.127-6.127C78.9,38,52.14,64.791,51.156,65.79Z"
        transform="translate(-0.182 -22.818)"
      />
    </svg>
  </span>
);

function getSelectedOption(options: optionType[], value: string) {
  for (const option of options) {
    if (option.value === value) {
      return option;
    }
  }
}
